import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PublicShell } from "../components/PublicShell";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";
import { Gavel, Timer } from "lucide-react";

function fmtCountdown(ends_at) {
  if (!ends_at) return "";
  const end = new Date(ends_at);
  const diff = end - new Date();
  if (diff <= 0) return "Ended";
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}

export default function AuctionsPage() {
  const [auctions, setAuctions] = useState([]);
  useEffect(() => {
    api.get("/auctions").then((r) => {
      const active = (r.data || []).filter((a) => a.status === "live" || a.status === "scheduled");
      setAuctions(active);
    });
  }, []);
  return (
    <PublicShell>
      <section className="hero-bg pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-end">
          <div>
            <div className="brand-divider max-w-xs mb-4"><span className="dot" /><span className="label-eyebrow" style={{ color: "var(--wakzy-red)" }}>Live auctions</span></div>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl mb-3"><span className="red-text">Bid live.</span> <span className="chrome-text">Drive home.</span></h1>
            <p className="text-slate-300 max-w-xl">Open to retail buyers and licensed dealers. Transparent reserve, real-time bid history, full vehicle inspection report on every lot.</p>
          </div>
          <div className="flex flex-wrap gap-3 lg:justify-end">
            <Link to="/auctions/register"><Button className="btn-cta rounded-sm h-12 px-8" data-testid="auctions-register-btn">Register to Bid</Button></Link>
          </div>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="label-eyebrow mb-6">{auctions.length} active lot{auctions.length === 1 ? "" : "s"}</div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {auctions.map((a) => (
            <Link key={a.id} to={`/auctions/${a.id}`} className="surface hover-lift rounded-md overflow-hidden block" data-testid={`auction-card-${a.id}`}>
              <div className="aspect-[16/9] bg-cover bg-center relative" style={{ backgroundImage: `url(${a.vehicle?.images?.[0] || ""})` }}>
                <div className="absolute top-3 left-3 pill pill-sold">{a.status}</div>
                <div className="absolute top-3 right-3 px-2 py-1 rounded text-xs font-mono flex items-center gap-1" style={{ background: "rgba(0,0,0,0.6)", color: "#f0c659" }}>
                  <Timer className="w-3 h-3" /> {fmtCountdown(a.ends_at)}
                </div>
              </div>
              <div className="p-5">
                <div className="text-xs text-slate-400">{a.vehicle?.year}</div>
                <h3 className="font-heading text-xl chrome-text inline-block">{a.vehicle?.make} {a.vehicle?.model}</h3>
                <div className="mt-3">
                  <div className="label-eyebrow">Current bid</div>
                  <div className="font-display text-3xl gold-text">${a.current_bid?.toLocaleString()}</div>
                </div>
                <div className="text-xs text-slate-500 mt-2">{a.bid_count || 0} bid{a.bid_count === 1 ? "" : "s"} · Min next ${(a.current_bid + (a.bid_increment || 250)).toLocaleString()}</div>
                <div className="mt-4 inline-flex items-center text-sm text-[#D4AF37]"><Gavel className="w-4 h-4 mr-1" /> Place bid →</div>
              </div>
            </Link>
          ))}
          {auctions.length === 0 && (
            <div className="surface p-12 rounded-md text-center col-span-full">
              <Gavel className="w-12 h-12 mx-auto mb-4 text-slate-600" />
              <div className="text-slate-400">No active auctions right now.</div>
            </div>
          )}
        </div>
      </section>
    </PublicShell>
  );
}
